"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconBase = _interopRequireDefault(require("./IconBase"));
var CheckMarkIcon = function CheckMarkIcon(props) {
  return _react["default"].createElement(_IconBase["default"], props, _react["default"].createElement("polyline", {
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.263,32.13 23.188,48.055 56.658,14.586 "
  }));
};
CheckMarkIcon.displayName = 'CheckMarkIcon';
var _default = CheckMarkIcon;
exports["default"] = _default;
CheckMarkIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckMarkIcon"
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["icons/CheckmarkIcon.js"] = {
    name: "CheckMarkIcon",
    docgenInfo: CheckMarkIcon.__docgenInfo,
    path: "icons/CheckmarkIcon.js"
  };
}